exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.task-header-img {\n    border-radius: 100px;\n    font-size: 100%;\n}\n\n.task-wrap {\n    display: table;\n    width: 100%;\n}\n\n.task-wrap .col {\n    display: table-cell;\n    vertical-align: top;\n}\n\n.task-wrap .v-middle {\n    vertical-align: middle;\n}\n\n.task-wrap .task-header-img-wrap {\n    width: 40px;\n}\n\n.task-wrap .mat-card-title {\n    font-size: 1.6rem;\n}\n\n.task-wrap h3 {\n    margin: 0;\n    font-weight: 600;\n    font-size: 1.6rem;\n}\n\n.task-wrap .date-area {\n    font-size: 80%;\n    margin-bottom: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/task/taskdetails/task-details.component.css
// module id = 2035
// module chunks = 0